import React from 'react';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import {Button} from "antd";
import EnhancedModal from "../../../../components/enhanced-modal";
import {MODAL_WIDTH_LG} from "../../../../styles/constants";
import {getFilterObjFromViewerObj} from "../../../../utils/filter";
import {connect} from "react-redux";
import {getPluginStandaloneWizardCsvRowListCsvRows} from "../actions";
import InfiniteScrollDataTable from "../../../../components/infinite-scroll-data-table";

const mapStateToProps = state => ({
    outputFilePath: state.scenes.utilities.plugins.outputFilePath,
    csvPreview: state.scenes.utilities.plugins.csvPreview,
    csvPreviewParams: state.scenes.utilities.plugins.csvPreviewParams,
});

const mapDispatchToProps = dispatch => ({
    fetchCsvRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath) =>
        dispatch(getPluginStandaloneWizardCsvRowListCsvRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath, 1))
});

const CSVPreview = ({
                        t,
                        isVisible,
                        onHide,
                        outputFilePath,
                        csvPreview,
                        csvPreviewParams,
                        fetchCsvRows
                    }) => {
    return (
        <EnhancedModal
            visible={isVisible}
            onCancel={onHide}
            title={t('scenes.dataManager.fileMapping.wizard.csvRowList.title')}
            width={MODAL_WIDTH_LG}
            footer={<Button onClick={onHide}>{t('commons.buttons.close.title')}</Button>}
        >
            {!!csvPreview && !!csvPreview.Data && !!csvPreview.Columns && (
                <InfiniteScrollDataTable
                    data={csvPreview && csvPreview.Data}
                    rowTotal={csvPreview && csvPreview.Count}
                    cols={csvPreview && csvPreview.Columns}
                    onChange={
                        ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => fetchCsvRows(
                            pageNum,
                            pageSize,
                            getFilterObjFromViewerObj(
                                csvPreview && csvPreview.Columns.filter(colName => colName !== 'NumRow'),
                                searchText,
                                filters
                            ),
                            sortCol ? [sortCol] : null,
                            sortByDesc,
                            csvPreviewParams.csvSeparator,
                            csvPreviewParams.csvDelimiter,
                            csvPreviewParams.csvHasHeader,
                            outputFilePath
                        )
                    }
                />
            )}
        </EnhancedModal>
    )
};

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps)
)(CSVPreview);
